<template>
  <div @click="toggle" class="ml-steps__item">
    <step :completed="completed" :show="show" @close="toggle">
      <div class="ml-steps-card__title">{{$t("mylist.childName")}}</div>
      <template v-slot:icon>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 7.5C7.5 7.35166 7.45602 7.20666 7.37361 7.08332C7.29119 6.95999 7.17406 6.86386 7.03702 6.80709C6.89997 6.75032 6.74917 6.73547 6.60369 6.76441C6.4582 6.79335 6.32456 6.86478 6.21967 6.96967C6.11478 7.07456 6.04335 7.2082 6.01441 7.35368C5.98548 7.49917 6.00033 7.64997 6.05709 7.78701C6.11386 7.92406 6.20999 8.04119 6.33333 8.1236C6.45666 8.20601 6.60167 8.25 6.75 8.25C6.94892 8.25 7.13968 8.17098 7.28033 8.03033C7.42099 7.88968 7.5 7.69891 7.5 7.5ZM10.875 10.545C10.7899 10.4951 10.6957 10.4625 10.5979 10.4491C10.5001 10.4356 10.4007 10.4416 10.3052 10.4667C10.2098 10.4918 10.1202 10.5355 10.0416 10.5952C9.9631 10.655 9.89713 10.7297 9.8475 10.815C9.76236 10.9647 9.63909 11.0892 9.49022 11.1758C9.34136 11.2623 9.17222 11.308 9 11.308C8.82779 11.308 8.65865 11.2623 8.50979 11.1758C8.36092 11.0892 8.23765 10.9647 8.1525 10.815C8.10288 10.7297 8.03691 10.655 7.95837 10.5952C7.87982 10.5355 7.79026 10.4918 7.6948 10.4667C7.59935 10.4416 7.49988 10.4356 7.4021 10.4491C7.30432 10.4625 7.21016 10.4951 7.125 10.545C6.95345 10.6439 6.828 10.8067 6.77601 10.9978C6.72402 11.1889 6.74972 11.3928 6.8475 11.565C7.06504 11.9436 7.37858 12.2581 7.75651 12.4769C8.13443 12.6956 8.56335 12.8107 9 12.8107C9.43665 12.8107 9.86558 12.6956 10.2435 12.4769C10.6214 12.2581 10.935 11.9436 11.1525 11.565C11.2503 11.3928 11.276 11.1889 11.224 10.9978C11.172 10.8067 11.0466 10.6439 10.875 10.545ZM11.25 6.75C11.1017 6.75 10.9567 6.79399 10.8333 6.8764C10.71 6.95881 10.6139 7.07594 10.5571 7.21299C10.5003 7.35003 10.4855 7.50083 10.5144 7.64632C10.5434 7.7918 10.6148 7.92544 10.7197 8.03033C10.8246 8.13522 10.9582 8.20665 11.1037 8.23559C11.2492 8.26453 11.4 8.24968 11.537 8.19291C11.6741 8.13614 11.7912 8.04001 11.8736 7.91668C11.956 7.79334 12 7.64834 12 7.5C12 7.30109 11.921 7.11032 11.7803 6.96967C11.6397 6.82902 11.4489 6.75 11.25 6.75ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.60299 15.006 6.24766 14.5244 5.16774 13.6381C4.08782 12.7518 3.35102 11.5165 3.08439 10.1452C2.81776 8.77382 3.03803 7.35242 3.7072 6.12608C4.37637 4.89974 5.4525 3.94536 6.75 3.4275C6.74229 3.53486 6.74229 3.64264 6.75 3.75C6.75 4.34674 6.98706 4.91903 7.40901 5.34099C7.83097 5.76295 8.40327 6 9 6C9.19892 6 9.38968 5.92098 9.53033 5.78033C9.67099 5.63968 9.75 5.44891 9.75 5.25C9.75 5.05109 9.67099 4.86032 9.53033 4.71967C9.38968 4.57902 9.19892 4.5 9 4.5C8.80109 4.5 8.61033 4.42098 8.46967 4.28033C8.32902 4.13968 8.25 3.94891 8.25 3.75C8.25 3.55109 8.32902 3.36032 8.46967 3.21967C8.61033 3.07902 8.80109 3 9 3C10.5913 3 12.1174 3.63214 13.2426 4.75736C14.3679 5.88258 15 7.4087 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z"
            fill="#424142"
          />
        </svg>
      </template>
      <template v-slot:modal>
        <div class="card-wizard">
          <div class="card-wizard__title">
            <h3 class="header-3">{{$t("mylist.childName")}}</h3>
          </div>
          <form class="card-wizard__container">
            <div class="bb-form-item bb-form-item--left w-100">
              <label for="childName" class="bb-form-label">
                {{ $t("mylist.widgetChildNameSubtitle") }}
              </label>
              <input
                v-model="childName"
                class="bb-form"
                type="text"
                maxlength="256"
                name="childName"
                id="childName"
                required=""
                :placeholder="$t('mylist.widgetChildNamePlaceholder')"
                @blur="childNameBlur"
              />

              <div class="bb-form-error" v-show="childNameHasError">
                {{ $t("generic.field_is_required") }}
              </div>
            </div>
            <label for="notDecided" class="bb-form-checkbox">
              <input
                class="mt-4"
                v-model="notDecided"
                type="checkbox"
                name="notDecided"
                id="notDecided"
              />
              {{ $t("mylist.widgetChildNameNoNameYet") }}
            </label>

            <div class="card-wizard__actions">
              <loading-button v-if="loading"></loading-button>
              <button
                v-else
                class="button button--primary button--block"
                @click.prevent="save"
                :disabled="disabled"
              >
                {{ $t("generic.save") }}
              </button>
            </div>
          </form>
        </div>
      </template>
    </step>
    <alert v-if="showAlertLocal" @retry="retry" :key="key" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Step from "./Step";
import LoadingButton from "../../../components/LoadingButton";
import OwnerListAlert from "./OwnerListAlert";
import { list } from "postcss";

export default {
  name: "ChildNameStep",
  components: {
    Step,
    "loading-button": LoadingButton,
    alert: OwnerListAlert,
  },
  data() {
    return {
      show: false,
      childName: "",
      notDecided: false,
      loading: false,
      childNameDirty: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
    }),
    childNameHasError() {
      if (this.notDecided) {
        return false;
      }
      return this.childName === "" && this.childNameDirty;
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "list_childname_step";
    },
    completed() {
      return this.list?.childName !== "" && this.list?.childName != null;
    },
    disabled() {
      if (this.notDecided) {
        return false;
      } else if (this.childName !== "") {
        return false;
      }
      return true;
    },
  },
  watch: {
    notDecided(newValue) {
      if (newValue) this.childName=""
    },
    list: {
      handler() {
        if (this.list?.childName === 'TBD') {
          this.childName = ''
          this.notDecided = true
        }
        else this.childName = this.list?.childName;
      },
      deep: true,
    },
  },
  methods: {
    childNameBlur() {
      this.childNameDirty = true;
      if (this.childName !== '') this.notDecided = false
    },
    async retry() {
      this.$store.commit("setAlertRetrying", true);
      await this.save();
      this.$store.commit("setAlertRetrying", false);
    },
    toggle() {
      this.show = !this.show;
    },
    async save() {
      this.loading = true;
      const childName = this.notDecided ? "TBD" : this.childName;
      try {
        await this.$store.dispatch('updateChildName',childName)
      } catch {
        this.loading = false;
        this.show = false;
        this.$alert.error(
          this.$t("mylist.widgetChildNameError"),
          true,
          this.key
        );
        this.$emit("updated");
        return;
      }
      this.$store.commit("updateUserField", {
        field: "childName",
        value: childName,
      });
      this.loading = false;
      this.show = false;
      this.$alert.success(
        this.$t("mylist.widgetChildNameSuccess"),
        this.key
      );
      window.mixpanel.track("Onboarding", {
        "Step Name": "Step 2: Child Name",
        Skipped: false,
        "Last O Slide": false,
        "On Seq Com": false,
      });
      window.mixpanel.people.increment("Steps Taken");
    },
  },
  mounted() {
    if (this.list?.childName === 'TBD') {
      this.childName = ''
      this.notDecided = true
    }
    else this.childName = this.list?.childName;
  },
};
</script>
